import { getHostUrl } from './../utility/APIUtility'
/* eslint-disable @typescript-eslint/no-explicit-any */
import { GET_FEATURED_APPS, GET_STAFF_PICKED_APPS } from './../constants/APIConstants'
import { GET_APP_LIST, GET_FILTERS, REQUEST_FOR_DEMO } from '../constants/APIConstants'
import { getCall, postCall } from '../utility/APIUtility'

export const getAllApps = (callback: any, queryUrl: string) => {
  const url = getHostUrl() + GET_APP_LIST + queryUrl
  getCall(url, callback)
}

export const getFeaturedApps = (callback: any) => {
  const url = getHostUrl() + GET_FEATURED_APPS
  getCall(url, callback)
}

export const getStaffPickedApps = (callback: any) => {
  const url = getHostUrl() + GET_STAFF_PICKED_APPS
  getCall(url, callback)
}

export const getFilters = (filterType: string, callback: any) => {
  const url = getHostUrl() + GET_FILTERS + filterType
  getCall(url, callback)
}

export const submitRequestForDemo = (callback:any, body:any) => {
  const url = getHostUrl() + REQUEST_FOR_DEMO
  postCall(url, callback, body)
}
